/**
 * /src/app.js
 */
import "../scss/style.scss";
import "@splidejs/splide/css/core";
import Splide from "@splidejs/splide";

document.addEventListener("DOMContentLoaded", () => {
  const setupTabs = tabContainerSelector => {
    const tabLists = document.querySelectorAll(tabContainerSelector);

    tabLists.forEach(tabList => {
      const tabs = tabList.querySelectorAll("a");
      if (tabs.length === 0) return;

      const targets = Array.from(tabs)
        .map(tab => {
          const href = tab.getAttribute("href");
          if (!href || !href.startsWith("#")) return null;
          return document.getElementById(href.substring(1));
        })
        .filter(el => el !== null);

      let activeTab = Array.from(tabs).find(tab => tab.classList.contains("is-active"));
      if (!activeTab) {
        activeTab = tabs[0];
        activeTab.classList.add("is-active");
      }

      const initialTargetId = activeTab.getAttribute("href").substring(1);
      targets.forEach(content => {
        content.style.display = content.id === initialTargetId ? "block" : "none";
      });

      tabs.forEach(tab => {
        tab.addEventListener("click", e => {
          e.preventDefault();

          tabs.forEach(item => item.classList.remove("is-active"));
          tab.classList.add("is-active");

          const targetId = tab.getAttribute("href").substring(1);
          targets.forEach(content => {
            content.style.display = content.id === targetId ? "block" : "none";
          });
        });
      });
    });
  };

  setupTabs(".p-schedule__tab");
  setupTabs(".p-ranking__tab");

  document.querySelectorAll(".p-ranking__tab-content").forEach(tabContent => {
    const btn = tabContent.querySelector(".p-ranking__btn");
    const table = tabContent.querySelector(".p-ranking__table");
    const btnLink = btn?.querySelector("a");

    if (!btn || !table || !btnLink) return;
    if (btnLink.getAttribute("href") !== "#") return;

    btnLink.addEventListener("click", e => {
      e.preventDefault();

      const rows = Array.from(table.querySelectorAll("tr")).filter(tr => !tr.querySelector("th"));
      const hiddenRows = rows.filter(tr => window.getComputedStyle(tr).display === "none");

      hiddenRows.slice(0, 20).forEach(tr => {
        tr.style.display = "table-row";
      });

      const remaining = rows.filter(tr => window.getComputedStyle(tr).display === "none");
      if (remaining.length === 0) {
        btn.style.display = "none";
      }
    });
  });

  const styleChart = document.querySelector(".p-detail__style-chart");
  if (styleChart) {
    const scores = [
      parseFloat(styleChart.dataset.score1) || 0,
      parseFloat(styleChart.dataset.score2) || 0,
      parseFloat(styleChart.dataset.score3) || 0,
      parseFloat(styleChart.dataset.score4) || 0,
      parseFloat(styleChart.dataset.score5) || 0,
    ];

    const cx = 166.001;
    const cy = 174.51;
    const maxScore = 5;
    const vertices = [
      { x: 63.79, y: 315.191, scoreIdx: 3 },
      { x: 0.621, y: 120.775, scoreIdx: 4 },
      { x: 166.001, y: 0.62, scoreIdx: 0 },
      { x: 331.381, y: 120.775, scoreIdx: 1 },
      { x: 268.212, y: 315.191, scoreIdx: 2 },
    ];

    const points = vertices.map(vertex => {
      const ratio = scores[vertex.scoreIdx] / maxScore;
      return {
        x: cx + (vertex.x - cx) * ratio,
        y: cy + (vertex.y - cy) * ratio,
      };
    });

    const d = points.map((point, index) => `${index === 0 ? "M" : "L"}${point.x.toFixed(3)} ${point.y.toFixed(3)}`).join("") + "Z";
    const path = styleChart.querySelector("svg path");

    if (path) path.setAttribute("d", d);
  }

  const grade2Cards = document.querySelector(".p-detail__grade2-list");
  if (grade2Cards) {
    new Splide(grade2Cards, {
      type: "loop",
      perPage: 4,
      gap: 27,
      pagination: true,
      breakpoints: {
        768: {
          destroy: true,
        },
      },
    }).mount();
  }
});
